<template>
  <el-config-provider :locale="locale" :empty-values="[undefined, null]">
    <router-view :key="computedKey"/>
  </el-config-provider>
</template>

<script setup>
import zhCn from 'element-plus/dist/locale/zh-cn.mjs';
// 解决日期时间国际化问题
import 'dayjs/locale/zh-cn';
import {useRoute} from "vue-router";
const route = useRoute()

const locale = ref(zhCn); //使用中文

const computedKey = computed(() => {
    const needRefreshPageNames = ['courseBriefDetail'] // 跳转名单(自身跳自身，但fullPath不同，需要强刷的页面)
    if (needRefreshPageNames.includes(route.name)) {
        return route.fullPath
    } else {
        return undefined
    }
})

onBeforeMount(() => {
  setFontSize();
});

window.addEventListener('resize', () => {
  setFontSize();
}, false);

function setFontSize() {
  const docWidth = Math.min(document.documentElement.clientWidth, 750);
  const designWidth = 375;
  document.documentElement.style.fontSize = `${ docWidth / designWidth * 100 }px`;
}

onMounted(() => {

});

// 解决tcplayer播放按钮点击失效
$('body').on('click', '.vjs-play-control', function() {
    try {
        $(this).off('click');
        const video = $(this).closest('.tcplayer').find('video').get(0);
        video.paused ? video.play() : video.pause();
        return false;
    } catch (e) {
    }
});
</script>

<style lang="scss">
.tcp-dynamic-watermark-content {
  font-size: 12px;
}

.tcplayer-copyright-tip {
  position: absolute;
  z-index: 99;
  padding: 10px;
  max-width: 100%;

  > p {
    font-size: 18px;
    background: rgba(0, 0, 0, 0.6);
    padding: 8px;
    border-radius: 4px;
    line-height: 1.5;
    color: #ffffff;
    display: inline-block;
  }
}
</style>
